import { Chunk } from "@abacus/common";

import { ChunkRunResult, Runner } from "./types";

export class BatchRunner<I, O> implements Runner<Chunk<I>, ChunkRunResult<O>> {
  readonly getTask: () => Runner<I, O>;

  constructor(getTask: () => Runner<I, O>) {
    this.getTask = getTask;
  }

  async run(chunk: Chunk<I>): Promise<ChunkRunResult<O>> {
    const errors: [number, string][] = [];
    const results: [number, O][] = [];
    const values = chunk.values;
    const startIndex = chunk.startIndex;
    for (let index = 0; index < values.length; ++index) {
      try {
        const task = this.getTask();
        const result = await task.run(values[index]);
        results.push([index + startIndex, result]);
      } catch (error) {
        errors.push([index + startIndex, (error as Error).message]);
      }
    }
    return {
      chunkIndex: chunk.chunkIndex,
      errors,
      startIndex: chunk.startIndex,
      success: values.length - errors.length,
      total: values.length,
      values: results,
    };
  }
}
